// <s-sticky-add-to-cart> shows a mobile buy bar while the main product form is off screen.
// data-target is the id of the product form to watch. The bar is inert while hidden so it can't take focus.
class StickyAddToCart extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = this.dataset.target ? document.getElementById(this.dataset.target) : null;
    if (!target) return;

    this.#observer = new IntersectionObserver((entries) => {
      const formVisible = entries[0]?.isIntersecting ?? true;
      this.toggleAttribute('data-visible', !formVisible);
      this.inert = formVisible;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-sticky-add-to-cart')) {
  customElements.define('s-sticky-add-to-cart', StickyAddToCart);
}
